import type { Directive } from 'vue'

/** Fades content up when it mounts, the way the design's entrance animations do, without hiding anything on failure. */
export const reveal: Directive<HTMLElement> = {
  mounted(element) {
    element.classList.add('reveal')
  },
}
